// import appleStore from './images/apple-store.svg'
// import googlePlay from './images/google-play.svg'
import mobileIcon from './images/mobileIcon.svg'
// import logo from './images/logo.svg'
import balance from './images/balance.svg'
import deposit from './images/deposit.svg'
// import footerLogo from './images/footer-logo.svg'
import invoiceImg from './images/invoice.svg'
import invoicePaymentIcon from './images/invoicePaymentIcon.svg'
import payment from './images/payment.svg'
import downloadIcon from './images/download.svg'
import timelineRegistryIcon from './images/timelineRegistryIcon.svg'
import medicineFormIcon from './images/medicineFormIcon.svg'


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    appLogoLight: require('./images/light/appLogo.png'),
    appLogoDark: require('./images/dark/appLogo.png'),
    eyworksLight: require('./images/light/eyworks.png'),
    eyworksDark: require('./images/dark/eyworks.png'),
    logoutIcon: require('./images/logoutIcon.png'),
    errorBg: require('./images/error.png'),
    successBg: require('./images/success.png'),

    eyMemoriesLogoLight: require('./images/light/eyMemoriesLogo.png'),
    eyMemoriesLogoDark: require('./images/dark/eyMemoriesLogo.png'),

    homeIconDark: require('./images/homeIconLight.png'),
    profileIconLight: require('./images/userIcon.png'),
    feedIconLight: require('./images/feedIconLight.png'),
    messageIconLight: require('./images/messageIconLight.png'),
    optionsIconLight: require('./images/optionsIconLight.png'),
    kinderGarden: require('./images/kinderGarden.png'),
    timelineIcon: require('./images/timelineIcon.png'),

    timelineRegistryIcon: timelineRegistryIcon,

    dailyDiaryIcon: require('./images/dailyDiary/dailyDiary.png'),
    fruitIcon: require('./images/dailyDiary/fruits.png'),
    sleepingIcon: require('./images/dailyDiary/sleeping.png'),
    babyDiaperIcon: require('./images/dailyDiary/babyDiaper.png'),
    toiletBowlIcon: require('./images/dailyDiary/toiletBowl.png'),
    babyBottleIcon: require('./images/dailyDiary/babyBottle.png'),
    notesIcon: require('./images/dailyDiary/notes.png'),
    photoIcon: require('./images/dailyDiary/photos.png'),
    checkedIcon: require('./images/dailyDiary/checked.png'),
    sunCreamIcon: require('./images/dailyDiary/sunCreamIcon.png'),

    dailyDiaryIconLight: require('./images/light/dailyDiary/dailyDiary.png'),
    fruitIconLight: require('./images/light/dailyDiary/fruits.png'),
    sleepingIconLight: require('./images/light/dailyDiary/sleeping.png'),
    babyDiaperIconLight: require('./images/light/dailyDiary/babyDiaper.png'),
    toiletBowlIconLight: require('./images/light/dailyDiary/toiletBowl.png'),
    babyBottleIconLight: require('./images/light/dailyDiary/babyBottle.png'),
    notesIconLight: require('./images/light/dailyDiary/notes.png'),
    photoIconLight: require('./images/light/dailyDiary/photos.png'),
    checkedIconLight: require('./images/light/dailyDiary/checked.png'),
    sunCreamIconLight: require('./images/light/dailyDiary/sunCreamIcon.png'),

    dailyDiaryIconDark: require('./images/dark/dailyDiary/dailyDiary.png'),
    fruitIconDark: require('./images/dark/dailyDiary/fruits.png'),
    sleepingIconDark: require('./images/dark/dailyDiary/sleeping.png'),
    babyDiaperIconDark: require('./images/dark/dailyDiary/babyDiaper.png'),
    toiletBowlIconDark: require('./images/dark/dailyDiary/toiletBowl.png'),
    babyBottleIconDark: require('./images/dark/dailyDiary/babyBottle.png'),
    notesIconDark: require('./images/dark/dailyDiary/notes.png'),
    photoIconDark: require('./images/dark/dailyDiary/photos.png'),
    sunCreamIconDark: require('./images/dark/dailyDiary/sunCreamIcon.png'),

    onTimeIconLight: require('./images/light/on-time.png'),
    onTimeIconDark: require('./images/dark/on-time.png'),
    rightArrowLight: require('./images/light/right-arrow.png'),
    rightArrowDark: require('./images/dark/arrow.png'),
    scanLight: require('./images/light/scan.png'),
    scanDark: require('./images/dark/scan.png'),

    noMessages: require('./images/noMessages.png'),

    // Media should be removed
    // mediaImg: require('./images/dailyDiary/ai.png'),

    // blank screen images
    noActivities: require('./images/noActivities.png'),
    noPostFound: require('./images/postIcon.png'),

    pdfIcon: require('./images/pdfIcon.png'),
    observationCardIcon: require('./images/observationCardIcon.png'),
    accidentSheetCardIcon: require('./images/accidentSheetCardIcon.png'),
    reportIcon: require('./images/reportIcon.png'),
    medicineFormIcon: medicineFormIcon,

    audioIcon: require('./images/audio.png'),
    commentIcon: require('./images/commentIcon.png'),

    // mediaImg: require('./images/dailyDiary/ai.png'),
    paymentCheck: require('./images/paymentCheck.png'),
    invoice: require('./images/invoice.png'),

    filterLight: require('./images/light/filter.png'),
    filterDark: require('./images/dark/filter.png'),
    worldpayIcon: require('./images/worldpay.png'),
    stripeIcon: require('./images/stripe.png'),
    opayoIcon: require('./images/opayo.png'),

    taxFreeChildcareLight: require('./images/light/taxFreeChildcare.png'),
    taxFreeChildcareDark: require('./images/dark/taxFreeChildcare.png'),
    worldPayLogoIcon: require('./images/worldPayLogo.png'),
    creditCard: require('./images/creditCards.png'),
    directDebit: require('./images/directDebit.png'),

    notABillPayer: require('./images/notABillPayer.png'),
    eyeIcon: require('./images/light/eye.png'),
    eyeIconDark: require('./images/dark/eye.png'),
    noNotifications: require('./images/no_notifications.png'),
    accountSummary: require('./images/accountSummary.png'),

    backIcon: require('./images/back.png'),
    arrowDownIcon: require('./images/arrow.png'),
    noPlanning: require('./images/noPlanning.png'),
    reportDownload: require('./images/reportDownload.png'),

    downloadIcon: require('./images/download.png'),
    linkIcon: require('./images/link.png'),

    appErrorIcon: require('./images/appError.png'),

    foundationIcon: require('./images/foundationIcon.png'),
    footStepsIcon: require('./images/footStepsIcon.png'),
    triangleIcon: require('./images/triangleIcon.png'),
    qrIconLight: require('./images/light/qr-code.png'),
    qrIconDark: require('./images/dark/qr-code.png'),
    appleStore: require('./images/applestore.png'),
    googlePlay: require('./images/playstore.png'),
    mobileIcon: mobileIcon,
    logo: require('./images/logo.png'),
    eyMemoriesLogo: require('./images/ey-memories-logo.png'),
    balance: balance,
    deposit: deposit,
    footerLogo: require('./images/footerlogo.png'),
    invoiceImg: invoiceImg,
    invoicePaymentIcon: invoicePaymentIcon,
    payment: payment,
    downloadIconSvg: downloadIcon,

    notificationIcon: require('./images/notification-icon.png'),
    accidentSheetIcon: require('./images/notificationEventTypes/icon-accident-sheet.png'),
    notificationBellDark: require('./images/dark/notificationBellDark.png'),
    notificationBellLight: require('./images/light/notificationBellLight.png'),

    diaryIcon: require('./images/notificationEventTypes/icon-diary.png'),
    documentIcon: require('./images/notificationEventTypes/icon-document.png'),
    medicineFormNotiIcon: require('./images/notificationEventTypes/icon-medicine-form.png'),
    messageIcon: require('./images/notificationEventTypes/icon-message.png'),
    observationIcon: require('./images/notificationEventTypes/icon-observation.png'),
    planningSheetIcon: require('./images/notificationEventTypes/icon-planning-sheet.png'),
    reportsIcon: require('./images/notificationEventTypes/icon-reports.png'),
    signInOutIcon: require('./images/notificationEventTypes/icon-sign-in-out.png'),
    invoiceIcon: require('./images/notificationEventTypes/icon-invoice.png'),
    eyengageIcon: require('./images/notificationEventTypes/icon-eyengage.png'),
    mailIcon: require('./images/icon-mail.png'),
    groupConversationIcon: require('./images/icon-group-conversation.png'),

    downloadAppScreen: require('./images/download-app-screen.png'),
    unSubscribeIcon: require('./images/unsubscribe.png'),
    arrowRightIcon: require('./images/arrowRight.png'),

    attachmentIcon: require('./images/attachment.png'),
    emailIcon: require('./images/email.png'),

    noMessageFound: require('./images/noMessage.png'),
    eyParentLogo: require('./images/eyParentLogo.png'),
    downloadAppImg: require('./images/downloadAppImg.png'),
    eyMemoriesAbstract: require('./images/downloadAppImgEy.png'),

    errorImg: require('./images/error-img.png'),
    successTick: require('./images/accept-1.png'),
    noDocumentFound: require('./images/no-document.png'),
    videoMediaIcon: require('./images/video-icon.png'),
    audioMediaIcon: require('./images/audio-icon.png'),
    diaryNotificationIconLight: require('./images/light/notificationEventTypes/icon-diary.png'),
    documentNotificationIconLight: require('./images/light/notificationEventTypes/icon-document.png'),
    messageNotificationIconLight: require('./images/light/notificationEventTypes/icon-message.png'),
    planningSheetNotificationIconLight: require('./images/light/notificationEventTypes/icon-planning-sheet.png'),
    invoiceNotificationIconLight: require('./images/light/notificationEventTypes/icon-invoice.png'),
    eyengageNotificationIconLight: require('./images/light/notificationEventTypes/icon-eyengage.png'),

    diaryNotificationIconDark: require('./images/dark/notificationEventTypes/icon-diary.png'),
    documentNotificationIconDark: require('./images/dark/notificationEventTypes/icon-document.png'),
    messageNotificationIconDark: require('./images/dark/notificationEventTypes/icon-message.png'),
    planningSheetNotificationIconDark: require('./images/dark/notificationEventTypes/icon-planning-sheet.png'),
    invoiceNotificationIconDark: require('./images/dark/notificationEventTypes/icon-invoice.png'),
    eyengageNotificationIconDark: require('./images/dark/notificationEventTypes/icon-eyengage.png'),

    listCollapsedLight: require('./images/light/icon-list-collapsed.png'),
    listCollapsedDark: require('./images/dark/icon-list-collapsed.png'),
    listExpandedLight: require('./images/light/icon-list-expanded.png'),
    listExpandedDark: require('./images/dark/icon-list-expanded.png'),
    mailIconLight: require('./images/light/icon-mail.png'),
    mailIconDark: require('./images/dark/icon-mail.png'),
    attachmentIconLight: require('./images/light/icon-attachment.png'),
    attachmentIconDark: require('./images/dark/icon-attachment.png'),
    noInternetIcon: require('./images/noInternet.png'),

    groupConversationLight: require('./images/light/icon-group-conversation.png'),
    groupConversationDark: require('./images/dark/icon-group-conversation.png'),

    onboarding01Light: require('./images/light/onboarding01.png'),
    onboarding02Light: require('./images/light/onboarding02.png'),
    onboarding03Light: require('./images/light/onboarding03.png'),
    onboarding04Light: require('./images/light/onboarding04.png'),
    onboarding05Light: require('./images/light/onboarding05.png'),
    onboarding06Light: require('./images/light/onboarding06.png'),

    onboarding01Dark: require('./images/dark/onboarding01.png'),
    onboarding02Dark: require('./images/dark/onboarding02.png'),
    onboarding03Dark: require('./images/dark/onboarding03.png'),
    onboarding04Dark: require('./images/dark/onboarding04.png'),
    onboarding05Dark: require('./images/dark/onboarding05.png'),
    onboarding06Dark: require('./images/dark/onboarding06.png'),

    questionMarkIconLight: require('./images/light/helper.png'),
    questionMarkIconDark: require('./images/dark/helper.png'),
    onboardingAppLogoLight: require('./images/light/onboarding-app-logo.png'),
    onboardingAppLogoDark: require('./images/dark/onboarding-app-logo.png'),
    onboardingIntro: require('./images/onboarding-intro.png'),

    legacyMessagesLight: require('./images/light/legacy.png'),
    legacyMessagesDark: require('./images/dark/legacy.png'),

    absentIcon: require('./images/absence.png'),
    holidayIcon: require('./images/holiday.png'),
    temperatureIcon: require('./images/temperature.png'),
    // arrowRightIcon: require('./images/arrowRight.png'),

    iconAddCircular: require('./images/icon-add-circular.png'),
    iconRemoveCircular: require('./images/icon-remove-circular.png'),
    iconCamera: require('./images/icon-camera.png'),
    iconPdfFile: require('./images/icon-pdf-file.png'),
    iconEmailNotification: require('./images/icon-email-notification.png'),

    arrowRightIconLight: require('./images/light/arrowRight.png'),
    arrowRightIconDark: require('./images/dark/arrowRight.png'),

    messageGroupLight: require('./images/light/message-group.png'),
    messageGroupDark: require('./images/dark/message-group.png'),

    noPaymentMethods: require('./images/noPaymentMethods.png'),
    warningIcon: require('./images/warning.png'),
    paymentSuccessFull: require('./images/paymentSuccessFull.png'),
    paymentFailed: require('./images/paymentFailed.png'),

    govIconLight: require('./images/light/govLogo.png'),
    govIconDark: require('./images/dark/govLogo.png'),

    creditCardsIcon: require('./images/creditCards.png'),

    locationIcon: require('./images/location.png'),
    calendarIcon: require('./images/calendar.png'),
    starIcon: require('./images/star.png'),
};
